module.exports = __webpack_public_path__ + "img/theme14.8cac3d9d.png";